import { Validator } from 'vee-validate';
import moment from 'moment-timezone';
import constants from '@/utils/constants';

export function convertFirestoreTimestampToDate(
  dateRaw: any,
  defaultDate: string = 'January 1, 2019'
): Date {
  if (dateRaw) {
    if (dateRaw.toDate) {
      return new Date(dateRaw.toDate());
    }
    return new Date(dateRaw);
  }
  return new Date(defaultDate);
}

export function stringToByte(text): number {
  let powers = { k: 1, m: 2, g: 3, t: 4 };
  let regex = /(\d+(?:\.\d+)?)\s?(k|m|g|t)?b?/i;

  let res = regex.exec(text);

  return res
    ? Number(res[1]) * Math.pow(1024, powers[res[2].toLowerCase()])
    : 0;
}

// date format validation
Validator.extend('date', {
  validate: value => {
    let year = [];
    let month = [];
    let day = [];
    for (let i = 0; i < value.toString().length; i++) {
      if (i <= 3) {
        // @ts-ignore
        year.push(...value.toString()[i]);
      }
      if (i > 3 && i <= 5) {
        // @ts-ignore
        month.push(...value.toString()[i]);
      }
      if (i > 5) {
        // @ts-ignore
        day.push(...value.toString()[i]);
      }
    }
    let date = moment([
      parseInt(year.join('')),
      parseInt(month.join('')) - 1,
      parseInt(day.join(''))
    ]);
    return date.isValid();
  },
  getMessage: field => `The ${field} is not a valid date.`
});

// time format validation
Validator.extend('times', {
  validate: value => {
    let timeStr = '000000' + value;
    let h = '';
    let val = timeStr.substr(timeStr.length - 6);
    for (let i = 1; i <= val.length; i++) {
      if (i % 2 === 0) {
        if (i === val.length) {
          h += val[i - 1];
        } else {
          h += val[i - 1] + ':';
        }
      } else {
        h += val[i - 1];
      }
    }
    let valid = moment(h, 'HH:mm:ss', true).isValid();
    return valid;
  },
  getMessage: field => `The ${field} is not a valid time.`
});

// hour validation
Validator.extend('valid_hour', {
  validate: (value, [other]: [any]) => {
    return value < other;
  },
  getMessage: field => `The ${field} is not a valid.`
});

// status validation
Validator.extend('status', {
  validate: value => {
    if (value === 'open' || value === 'close') {
      return true;
    } else {
      return false;
    }
  },
  getMessage: field => `The ${field} is not a valid value.`
});

// day validation
Validator.extend('valid_day', {
  validate: (value, [other]: [any]) => {
    return value <= other;
  },
  getMessage: field => `The ${field} is not a valid.`
});

// order type validation
Validator.extend('order_type', {
  validate: value => {
    if (
      value === constants.HMD ||
      value === constants.QRO ||
      value === constants.PPTA ||
      value === constants.PPDI ||
      value === constants.TOP ||
      value === constants.ROOM ||
      value === constants.OTHERS
    ) {
      return true;
    } else {
      return false;
    }
  },
  getMessage: field => `The ${field} is not a valid type.`
});

// max length validation
Validator.extend('maxLength', {
  validate: (value, [other]: [any]) => {
    if (value.length <= other) {
      return true;
    } else {
      return false;
    }
  },
  getMessage: (field, other) => `Sorry, maximum length is ${other} characters.`
});

// min length validation
Validator.extend('minLength', {
  validate: (value, [other]: [any]) => {
    if (value.length >= other) {
      return true;
    } else {
      return false;
    }
  },
  getMessage: (field, other) => `Sorry, minimum length is ${other} characters.`
});

// min value validation
Validator.extend('minVal', {
  validate: (value, [other]: [any]) => {
    if (value >= other) {
      return true;
    } else {
      return false;
    }
  },
  getMessage: (field, other) => `Sorry, minimum value is ${other}.`
});

// check validation for alpha numeric with dot
Validator.extend('alpha_num_dot', {
  validate: value => {
    return !/[^a-zA-Z0-9\\.]/g.test(value);
  },
  getMessage: field =>
    `Sorry, only letters (a-z), numbers (0-9), and periods (.) are allowed.`
});

// check validation for alpha numeric with space
Validator.extend('alpha_num_space', {
  validate: value => {
    return !/[^a-zA-Z\\ ]/g.test(value);
  },
  getMessage: field => `Sorry, only letters (a-z) and space ( ) are allowed.`
});

Validator.extend('whatsAppIDFormat', {
  validate: value => /^\+[0-9]{1,5}-[0-9]{5,12}$/.test(value),
  getMessage: field =>
    `Sorry, the ${field} format should be something like '+62-12345678'.`
});

Validator.extend('phoneNumberFormat', {
  validate: value => /^\+[0-9]{1,5}-[0-9]{5,12}$/.test(value),
  getMessage: field =>
    `Sorry, the ${field} format should be something like '+62-12345678'.`
});

Validator.extend('serviceCharge', {
  validate: value => {
    value = Number(value);
    if (value < 0 || value > 100) {
      return false;
    } else {
      return true;
    }
  },
  getMessage: field => `Sorry,  Only enter numbers between 0-100.`
});

Validator.extend('characters', {
  validate: value => /^\d*\.?\d*$/.test(value),
  getMessage: field => 'Special characters are not allowed'
});

Validator.extend('validField', {
  validate: value => value.length,
  getMessage: field => `Sorry, the ${field} should not to be empty.`
});
